// Matomo Analytics Utility
// Only initializes tracking when user has consented to analytics cookies

let matomoInitialized = false;

/**
 * Initialize Matomo tracking
 * Should only be called after user consents to analytics cookies
 */
export const initializeMatomo = () => {
  if (matomoInitialized) {
    // Already initialized, just track the current page
    if (window._paq) {
      window._paq.push(['trackPageView']);
    }
    return;
  }

  // Initialize the _paq array
  window._paq = window._paq || [];
  
  // Track the current page view
  window._paq.push(['trackPageView']);
  window._paq.push(['enableLinkTracking']);
  
  // Configure Matomo
  const u = "//analytics.voicelessmail.com/";
  window._paq.push(['setTrackerUrl', u + 'matomo.php']);
  window._paq.push(['setSiteId', '2']);
  
  // Load the Matomo script
  const d = document;
  const g = d.createElement('script');
  const s = d.getElementsByTagName('script')[0];
  g.async = true;
  g.src = u + 'matomo.js';
  s.parentNode.insertBefore(g, s);
  
  matomoInitialized = true;
  console.log('Matomo analytics initialized with consent');
};

/**
 * Opt user out of Matomo tracking
 */
export const optOutMatomo = () => {
  if (window._paq) {
    window._paq.push(['optUserOut']);
  }
};

/**
 * Remove opt-out and resume tracking
 */
export const optInMatomo = () => {
  if (window._paq) {
    window._paq.push(['forgetUserOptOut']);
  }
};

/**
 * Check if user has consented to analytics
 */
export const hasAnalyticsConsent = () => {
  const consent = localStorage.getItem('cookieConsent');
  if (!consent) return false;
  
  if (consent === 'accepted') return true;
  if (consent === 'declined') return false;
  
  // Check custom preferences
  const preferences = localStorage.getItem('cookiePreferences');
  if (preferences) {
    try {
      const parsed = JSON.parse(preferences);
      return parsed.analytics === true;
    } catch (e) {
      return false;
    }
  }
  
  return false;
};

/**
 * Initialize Matomo if user has previously consented
 * Call this on app startup
 */
export const initializeMatomoIfConsented = () => {
  if (hasAnalyticsConsent()) {
    initializeMatomo();
  }
};
